/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_SchedulerService_Dtos_RecurrenceType_RecurrenceTypeDto } from '../models/Wealthlane_SchedulerService_Dtos_RecurrenceType_RecurrenceTypeDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RecurrenceTypeService {

    /**
     * @returns Wealthlane_SchedulerService_Dtos_RecurrenceType_RecurrenceTypeDto OK
     * @throws ApiError
     */
    public static getApiSchedulerApiAppRecurrenceTypeRecurrenceTypes(): CancelablePromise<Array<Wealthlane_SchedulerService_Dtos_RecurrenceType_RecurrenceTypeDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/scheduler/api/app/recurrence-type/recurrence-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
